export default __webpack_public_path__ + "static/media/redbus.ca44d089.png";